/* eslint no-console:0 */
console.log('Webpacker compiled - site.');

// import 'es6-promise/auto'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// import 'babel-polyfill'
import "vue-trix"
//DatePicker
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'

import Vue from 'vue/dist/vue.esm'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'

import vSelect from 'vue-select'

Vue.component('v-select', vSelect);

Vue.use(BootstrapVue);
Vue.use(Vuex);
Vue.use(DatePicker);

import App from '../app.vue'
import ToursSearchForm from "../site/components/tours_search/ToursSearchForm";
import TourBookingForm from "../site/components/tour_booking/TourBookingForm";
import OrderPage from "../site/components/order/OrderPage";
import MessagesList from '../components/messages/MessagesList';
import AlertPanel from "../components/alerts/alertPanel";
import DocumentList from "../components/documents/DocumentList"

import store from '../store/agent_store'
import {getWSUrl} from "../extras/websocket_url";

import ActionCableVue from 'actioncable-vue';
Vue.use(DatePicker);
Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'error',
  // or function which returns a string with your JWT appended to your server URL as a query parameter
  connectionUrl: getWSUrl(),
  connectImmediately: true,
});



Vue.component('app', App);
Vue.component('tours-search-form', ToursSearchForm);
Vue.component('tour-booking-form', TourBookingForm);
Vue.component('order-page', OrderPage);
Vue.component('messages-list', MessagesList);
Vue.component('alert-panel', AlertPanel);
Vue.component('document-list', DocumentList);


let moment = require('moment');
moment.defaultFormat= 'YYYY-MM-DD';
moment.locale('ru');

import {set_toast_host} from '../components/shared/api_errors';

document.addEventListener('DOMContentLoaded', () => {
  //csrf
  const csrfMeta = document.head.querySelector('meta[name=csrf-token]')
  Vue.prototype.$csrf_token = csrfMeta ? csrfMeta.content : null;
  Vue.prototype.$rails_env = process.env.RAILS_ENV;
  const app = new Vue({
    el: '[data-behavior="vue"]',
    store
  })
  // корневой инстанс для тостов из кода вне компонентов (store/api)
  set_toast_host(app);
})

